// 挂载到vue原型上的VUE方法和属性
import Vue from "vue";

// 开发环境与生产环境的切换
const domainArr = location.href.split("/");
Vue.prototype.$imageUrl =
  process.env.NODE_ENV === "development"
    ? "http://mp.bayou-tech.cn/"
    : `${domainArr[0]}//${domainArr[2]}/`;
Vue.prototype.$uploadImageUrl =
  process.env.NODE_ENV === "development"
    ? "/apis/"
    : `${domainArr[0]}//${domainArr[2]}/`;

Vue.config.productionTip = false;
